module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent3",
    attrs: {
      "id": "fm2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Yes, Virginia, there is a Santa Claus. . . . Alas, how dreary would be the world if there were no Santa Claus. . . . There would be no childlike faith, then, no poetry, no romance to make tolerable this existence. We should have no enjoyment, except in sense and sight. The Eternal light with which childhood fills the world would be extinguished.")]), _vm._v(" "), _c('p', {
    staticClass: "attributec"
  }, [_vm._v("—Francis Church")]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Speak truth to power.")]), _vm._v(" "), _c('p', {
    staticClass: "attributec"
  }, [_vm._v("—Elie Wiesel"), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7256056e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm2.vue
// module id = 75
// module chunks = 0